<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="login login-1 d-flex flex-column flex-lg-row flex-column-fluid login-signin-on"
      id="kt_login"
      :style="{ backgroundImage: `url(${loginBg})` }"
    >
      <!--begin::Aside-->
      <div
        class="login-aside d-flex flex-column flex-row-auto"
        style="background-color: #422e87"
      >
        <div class="d-flex flex-column-auto flex-column pt-lg-40 pt-10">
          <div class="text-center mb-10">
            <img
              :src="require('@/assets/images/logo.svg')"
              class="max-h-70px"
              alt="logo image"
            />
          </div>
          <h3
            class="font-weight-bolder text-center font-size-h4 font-size-h1-lg px-5"
            style="color: #fff"
          >
            Welcome To Squadio Dashboard
          </h3>
        </div>
        <div
          class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center"
          :style="{ backgroundImage: `url(${backgroundImage})` }"
        ></div>
      </div>
      <!--begin::Aside-->
      <!--begin::Content-->
      <div
        class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto w-100"
      >
        <div class="d-flex flex-column-fluid flex-center">
          <!--begin::Signin-->
          <div class="login-form login-signin">
            <div class="form" id="kt_login_signin_form">
              <div class="form-group">
                <label class="font-size-h6 font-weight-bolder text-dark"
                  >Sign in with your Squadio Google account</label
                >
              </div>
              <div
                class="alert alert-custom alert-light-warning font-weight-bold mb-8"
                role="alert"
              >
                <div class="alert-text">
                  Only accounts registered as dashboard users can sign in. If
                  there is no account created for your email, please contact the
                  Product Team.
                </div>
              </div>
              <div class="pb-lg-0 pb-5">
                <button
                  type="button"
                  class="btn btn-yellow font-weight-bolder font-size-h6 px-15 py-4 my-3 mr-3"
                  :class="{ 'spinner spinner-light spinner-right': signingIn }"
                  :disabled="signingIn"
                  @click="signInWithGoogle"
                >
                  <img
                    :src="googleIcon"
                    class="mr-3 align-text-bottom"
                    width="20"
                    height="20"
                    alt=""
                  />
                  Sign in with Google
                </button>
              </div>
              <div class="form__error-label mt-2" v-if="error">
                {{ error }}
              </div>
            </div>
          </div>
          <!--end::Signin-->
        </div>
      </div>
      <!--end::Content-->
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import { mapGetters } from "vuex";

// Firebase error codes raised when the admin simply closes or re-opens the popup: nothing to report
const CANCELLED_POPUP_CODES = [
  "auth/popup-closed-by-user",
  "auth/cancelled-popup-request",
];

export default {
  name: "login-1",
  data() {
    return {
      signingIn: false,
      error: null,
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/isAuthUser",
    }),
    backgroundImage() {
      return (
        process.env.BASE_URL + "media/svg/illustrations/login-visual-1.svg"
      );
    },
    googleIcon() {
      return process.env.BASE_URL + "media/svg/social-icons/google.svg";
    },
    loginBg() {
      return require("@/assets/images/login-bg.svg");
    },
  },
  created() {
    // check if current user is authenticated
    if (this.isAuthenticated) {
      this.$router.push({ name: "talents-list" });
    }
  },
  methods: {
    async signInWithGoogle() {
      this.error = null;
      this.signingIn = true;

      try {
        await this.$store.dispatch("auth/loginWithGoogle");
        this.$router.push(
          this.$route.query.redirect || { name: "talents-list" }
        );
      } catch (e) {
        if (!CANCELLED_POPUP_CODES.includes(e?.code)) {
          this.error =
            e?.response?.data?.message ||
            e?.message ||
            "Sign-in failed, please try again.";
        }
      } finally {
        this.signingIn = false;
      }
    },
  },
};
</script>

<style lang="scss">
.login.login-1 {
  background-color: #fafafa;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right bottom;
}
</style>
